export default {
    entityTagPicker_untagged: "Sin etiquetar",
    entityTagPicker_noMore: "No hay más elementos",
    entityTagPicker_noFound: "No hay elementos",
    entityTagPicker_includeUnassigned: "Incluir conductores no asignados"
};